import { render, staticRenderFns } from "./RankingImpulsa.vue?vue&type=template&id=b0e1b6a2"
import script from "./RankingImpulsa.vue?vue&type=script&lang=js"
export * from "./RankingImpulsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports